import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from 'assets/img/header/homeLogo.png';
import _imports_1 from 'assets/img/header/navLogo.png';
const _withScopeId = n => (_pushScopeId("data-v-61ab6cb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fix-container"
};
const _hoisted_2 = {
  class: "top-container"
};
const _hoisted_3 = {
  class: "top-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "纳百川成就新伟业！思进取赢得万年传！优品质创建新格局！", -1));
const _hoisted_5 = {
  class: "nav-container"
};
const _hoisted_6 = {
  class: "nav-content"
};
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "nav-logo"
};
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "nav-logo"
};
const _hoisted_9 = {
  class: "nav"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {
      home: $options.page == 'home' && !$data.fixed,
      fixed: $data.fixed
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: "link-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goInner && $options.goInner(...args))
  }, "进入内网")])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$options.page == 'home' && !$data.fixed ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8)), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.name
    }, [Array.isArray(item.dropdownList) && item.dropdownList.length !== 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
      key: 0,
      teleported: false
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dropdownList, (dropdownItem, index) => {
          return _openBlock(), _createBlock(_component_el_dropdown_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              onClick: $event => $options.goNav(dropdownItem.path)
            }, _toDisplayString(dropdownItem.name), 9, _hoisted_11)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 2
      }, 1024)]),
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["nav-item", {
          active: item.components.includes($options.page)
        }]),
        onClick: $event => $options.goNav(item.path)
      }, _toDisplayString(item.name), 11, _hoisted_10)]),
      _: 2
    }, 1024)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(["nav-item", {
        active: item.components.includes($options.page)
      }]),
      onClick: $event => $options.goNav(item.path)
    }, _toDisplayString(item.name), 11, _hoisted_12))]);
  }), 128))])])])])], 2);
}